





























































import * as D from '../data'
import moment from 'moment'
import _ from 'underscore'

import { Prop, Component, Watch, Vue } from 'vue-property-decorator';

@Component({
  components: {
  }
})

export default class List extends Vue {
  private editing_problem: D.HornProblem | null = null
  private problemh: { [key:string]: D.HornProblem } = {}
  private active_tag: { [key:string]: boolean } = {}
  private contests: D.HornContest[] = []
  private contesth: { [key:string]: D.HornContest } = {}
  private query: string = ""
  private editing: string = ""
  private tag_add: string[] = []
  get fquery() {
    return (this.query || "").trim()
  }
  private used_tag: { [key:string]:number} = {}

  private sorting: "categorical" | "endtime" = "categorical"
  private visibility: string[] = []

  get problems() {
    const ps:　D.HornProblem[] = []
    this.contests.forEach(c => {
      if (c.problems) {
        c.problems.forEach(p => ps.push(p))
      }
    })
    return ps
  }

  get tags(): { tag: string, count: number }[] {
    const ts: { [key:string]: number } = {}
    const fp = this.fproblems
    Object.keys(fp).forEach(cid => {
      fp[cid].forEach(p => {
        Object.keys(p.tag).forEach(t => {
          ts[t] = (ts[t] || 0) + 1
        })
      })
    })
    const std = _(Object.keys(ts)).sortBy((t:string) => -ts[t])
    return std.map(t => <{ tag: string, count: number }>({ tag: t, count: ts[t] }))
  }

  get tags_to_add() {
    return Object.keys(this.used_tag)
  }

  get fproblems() {
    const q = this.fquery
    const rex = q ? new RegExp(q, "i") : undefined
    const f: { [key:string]: D.HornProblem[] } = {}
    const th = Object.keys(this.active_tag).length > 0 ? this.active_tag : undefined
    this.problems.forEach(p => {
      if (rex && !rex.test(p.title)) {
        return 
      }
      if (th) {
        if (Object.keys(th).some(t => !p.tag[t])) { return }
      }
      f[p.contest_id] = f[p.contest_id] || []
      f[p.contest_id].push(p)
    })
    return f
  }

  get fcontests() {
    if (this.visibility.length === 0) { return this.contests }
    const h: { [key:string]: boolean } = {}
    this.visibility.forEach(k => h[k] = true)
    const f: (c:D.HornContest) => boolean = (c) => {
      if (h.rated && !c.rate_change) { return false }
      return true
    }
    return this.contests.filter(c => f(c))
  }

  async fetch_tags() {
    const cs = await D.Contest.fetch_with_problems()
    cs.forEach(c => this.contests.push(c))
    console.log(this.contests_ABC, this.contests_ARC, this.contests_AGC)
  }

  async fetch_contests() {
    const cs = await D.Contest.fetch_with_problems()
    cs.forEach(c => {
      this.contests.push(c)
      this.contesth[c.id] = c
      if (c.problems) {
        c.problems.forEach(p => {
          this.problemh[p.id] = p
          Object.keys(p.tag || {}).forEach(t => this.used_tag[t] = 1)
        })
      }
    })
    console.log(this.contests_ABC, this.contests_ARC, this.contests_AGC)
  }

  lotime(time: Date) {
    return moment(time).format("YYYY-MM-DD HH:mm")
  }

  select_tag(name: string) {
    if (this.active_tag[name]) {
      this.$delete(this.active_tag, name)
    } else {
      this.$set(this.active_tag, name, true)
    }
  }

  get contest_pairs() {
    if (this.sorting === "categorical") {
      return [
        { name: "ABC", contests: this.contests_ABC },
        { name: "ARC", contests: this.contests_ARC },
        { name: "AGC", contests: this.contests_AGC },
        { name: "Others", contests: this.contests_Others },
      ]
    } else {
      return [
        { name: "", contests: this.fcontests }
      ]
    }
  }

  get contests_ABC() {
    return this.fcontests.filter(c => c.ABC)
  }

  get contests_ARC() {
    return this.fcontests.filter(c => c.ARC)
  }

  get contests_AGC() {
    return this.fcontests.filter(c => c.AGC)
  }

  get contests_Others() {
    return this.fcontests.filter(c => !c.ABC && !c.ARC && !c.AGC)
  }

  select(id: string) {
    const p = this.problemh[id]
    if (!p) { return }
    this.tag_add = Object.keys(p.tag)
    this.editing_problem = p
    this.editing = id
    console.log(this.editing)
    // this.$nextTick(() => {
    //   const es = this.$refs[`edit_${id}`]
    //   if (!es) { return }
    //   es[0].focus()
    // })
  }

  deselect_problem() {
    this.editing = ""
  }

  remove_tag(problem: D.HornProblem, tag: D.HornProblemTag) {
    this.$delete(problem.tag, tag.name)
    console.log(this.active_tag, this.tags)
    Object.keys(this.active_tag).forEach(tag => {
      if (!this.tags.find(tn => tn.tag === tag)) {
        this.select_tag(tag)
      }
    })
    D.Problem.set_tag(problem)
    this.$forceUpdate()
  }

  @Watch("tag_add")
  add_tag() {
    const ta = this.tag_add 
    const p = this.editing_problem
    if (!p) { return }
    const tags: { [key:string]: D.HornProblemTag } = {}
    ta.forEach(t => tags[t] = { name: t })
    console.log({ ta, p })
    this.$set(p, "tag", tags)
    D.Problem.set_tag(p)
  }

  mounted() {
    this.fetch_contests()
  }
}
